import { translate as t } from '@/lib/i18n';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error('ErrorBoundary caught error', error, info);
    }
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg-0 p-8 text-center">
          <div className="max-w-md space-y-2">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-rose">
              {t('Exception non gérée', 'Unhandled exception')}
            </div>
            <h1 className="text-xl font-semibold tracking-tight text-text-1">
              {t('Une erreur est survenue', 'Something went wrong')}
            </h1>
            <p className="font-mono text-xs text-text-3">{this.state.error.message}</p>
          </div>
          <Button onClick={this.reset} variant="secondary" size="sm">
            {t('Réessayer', 'Try again')}
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
